// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SteppersOrders_container__d\\+3nq {
  animation: SteppersOrders_init__c0mBt 1s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_firstStep__Ni0Fl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_title__Q8G9M {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_title__Q8G9M h4 {
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin: 0;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_firstStep__Ni0Fl .SteppersOrders_input__nOVqs {
  margin-top: 30px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_toggleButton__gO2s5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_toggleButton__gO2s5 h3 {
  font-size: 1.2rem;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_filterByType__ouECU {
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_filterByType__ouECU p {
  color: #5a5a5a;
  font-size: 1rem;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_twoData__vhVTv {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

/*---Información---*/
.SteppersOrders_container__d\\+3nq .SteppersOrders_twoData__vhVTv .SteppersOrders_tableContainer__Q5c1Y {
  animation: SteppersOrders_init__c0mBt 1s;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_newElemButton__oaYko {
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_stepTwoForm__QEsZy {
  animation: SteppersOrders_init__c0mBt 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_stepTwoForm__QEsZy h3 {
  width: 100%;
  font-size: 1.2rem;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_stepTwoForm__QEsZy .SteppersOrders_addForm__pZ2ti {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_stepTwoForm__QEsZy .SteppersOrders_addForm__pZ2ti .SteppersOrders_input__nOVqs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_stepTwoForm__QEsZy .SteppersOrders_addForm__pZ2ti .SteppersOrders_input__nOVqs p {
  margin: 0 0 0 10px;
  font-size: 1.5rem;
  font-weight: 500;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_stepTwoForm__QEsZy .SteppersOrders_addForm__pZ2ti .SteppersOrders_input__nOVqs span {
  margin: 0 0 0 10px;
  font-size: 1.2rem;
  font-weight: 300;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_noActiveGames__j8s-L {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 1.2rem;
  font-weight: 300;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_confirmHeaderData__sOfxy {
  display: flex;
  justify-content: center;
  align-items: center;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_confirmHeaderData__sOfxy .SteppersOrders_data__o22RK span {
  font-size: 1.3rem;
  border-bottom: 1px solid grey;
}

.SteppersOrders_container__d\\+3nq .SteppersOrders_confirmHeaderData__sOfxy .SteppersOrders_data__o22RK p {
  font-size: 1.1rem;
  margin-top: 10px;
}

@keyframes SteppersOrders_init__c0mBt {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.SteppersOrders_confirm__4RCqj {
  animation: SteppersOrders_init__c0mBt 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/*---Title---*/
.SteppersOrders_confirm__4RCqj .SteppersOrders_titleContainer__VOxEN {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_titleContainer__VOxEN h4 {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_titleContainer__VOxEN .SteppersOrders_arrow__AxDTH {
  transition: 0.3s;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_titleContainer__VOxEN .SteppersOrders_arrow__AxDTH:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_info__cKJjm {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 50px;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_info__cKJjm .SteppersOrders_accordion__QjWSl {
  border-radius: 10px;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_info__cKJjm .SteppersOrders_summary__-9Zmm {
  display: flex;
  justify-content: space-between;
  width: 95%;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_info__cKJjm .SteppersOrders_summary__-9Zmm .SteppersOrders_titleData__CuDaF {
  font-size: 1rem;
  font-family: Roboto, sans-serif;
  font-weight: 400;
}

.SteppersOrders_confirm__4RCqj .SteppersOrders_info__cKJjm .SteppersOrders_information__yr0kC {
  font-size: 1.2rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-top: 20px;
}

/*---Información---*/
.SteppersOrders_confirm__4RCqj .SteppersOrders_tableContainer__Q5c1Y {
  margin-top: 30px;
  border-radius: 5px;
  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/OrdenesPedido/Create/Steppers/SteppersOrders.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,wCAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .firstStep {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 50px;\n}\n\n.container .title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.container .title h4 {\n  font-size: 1.5rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n}\n\n.container .firstStep .input {\n  margin-top: 30px;\n}\n\n.container .toggleButton {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.container .toggleButton h3 {\n  font-size: 1.2rem;\n}\n\n.container .filterByType {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.container .filterByType p {\n  color: #5a5a5a;\n  font-size: 1rem;\n}\n\n.container .twoData {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n/*---Información---*/\n.container .twoData .tableContainer {\n  animation: init 1s;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .newElemButton {\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.container .stepTwoForm {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.container .stepTwoForm h3 {\n  width: 100%;\n  font-size: 1.2rem;\n}\n\n.container .stepTwoForm .addForm {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .stepTwoForm .addForm .input {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .stepTwoForm .addForm .input p {\n  margin: 0 0 0 10px;\n  font-size: 1.5rem;\n  font-weight: 500;\n}\n\n.container .stepTwoForm .addForm .input span {\n  margin: 0 0 0 10px;\n  font-size: 1.2rem;\n  font-weight: 300;\n}\n\n.container .noActiveGames {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  font-size: 1.2rem;\n  font-weight: 300;\n}\n\n.container .confirmHeaderData {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .confirmHeaderData .data span {\n  font-size: 1.3rem;\n  border-bottom: 1px solid grey;\n}\n\n.container .confirmHeaderData .data p {\n  font-size: 1.1rem;\n  margin-top: 10px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.confirm {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/*---Title---*/\n.confirm .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.confirm .titleContainer h4 {\n  width: 100%;\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.confirm .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.confirm .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.confirm .info {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-bottom: 50px;\n}\n\n.confirm .info .accordion {\n  border-radius: 10px;\n}\n\n.confirm .info .summary {\n  display: flex;\n  justify-content: space-between;\n  width: 95%;\n}\n\n.confirm .info .summary .titleData {\n  font-size: 1rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n}\n\n.confirm .info .information {\n  font-size: 1.2rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-top: 20px;\n}\n\n/*---Información---*/\n.confirm .tableContainer {\n  margin-top: 30px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SteppersOrders_container__d+3nq`,
	"init": `SteppersOrders_init__c0mBt`,
	"firstStep": `SteppersOrders_firstStep__Ni0Fl`,
	"title": `SteppersOrders_title__Q8G9M`,
	"input": `SteppersOrders_input__nOVqs`,
	"toggleButton": `SteppersOrders_toggleButton__gO2s5`,
	"filterByType": `SteppersOrders_filterByType__ouECU`,
	"twoData": `SteppersOrders_twoData__vhVTv`,
	"tableContainer": `SteppersOrders_tableContainer__Q5c1Y`,
	"newElemButton": `SteppersOrders_newElemButton__oaYko`,
	"stepTwoForm": `SteppersOrders_stepTwoForm__QEsZy`,
	"addForm": `SteppersOrders_addForm__pZ2ti`,
	"noActiveGames": `SteppersOrders_noActiveGames__j8s-L`,
	"confirmHeaderData": `SteppersOrders_confirmHeaderData__sOfxy`,
	"data": `SteppersOrders_data__o22RK`,
	"confirm": `SteppersOrders_confirm__4RCqj`,
	"titleContainer": `SteppersOrders_titleContainer__VOxEN`,
	"arrow": `SteppersOrders_arrow__AxDTH`,
	"info": `SteppersOrders_info__cKJjm`,
	"accordion": `SteppersOrders_accordion__QjWSl`,
	"summary": `SteppersOrders_summary__-9Zmm`,
	"titleData": `SteppersOrders_titleData__CuDaF`,
	"information": `SteppersOrders_information__yr0kC`
};
export default ___CSS_LOADER_EXPORT___;
